import { useState, useEffect } from 'react';
import axios from 'axios';
import AdminLayout from '@/components/AdminLayout';
import { API } from '@/App';
import { Users, Briefcase, FolderKanban, FileText, Mail, MessageSquare } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    services: 0,
    projects: 0,
    blog: 0,
    messages: 0,
    quotes: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const results = await Promise.allSettled([
          axios.get(`${API}/services`),
          axios.get(`${API}/projects`),
          axios.get(`${API}/blog`),
          axios.get(`${API}/contact`),
          axios.get(`${API}/quotes`),
        ]);

        const getData = (result) => result.status === 'fulfilled' ? result.value.data : [];

        setStats({
          services: getData(results[0]).length,
          projects: getData(results[1]).length,
          blog: getData(results[2]).length,
          messages: getData(results[3]).filter(m => !m.read).length,
          quotes: getData(results[4]).filter(q => q.status === 'pending').length,
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };
    fetchStats();
  }, []);

  const statCards = [
    { label: 'Hizmetler', value: stats.services, icon: Briefcase, color: 'blue' },
    { label: 'Projeler', value: stats.projects, icon: FolderKanban, color: 'green' },
    { label: 'Blog Yazıları', value: stats.blog, icon: FileText, color: 'purple' },
    { label: 'Okunmamış Mesajlar', value: stats.messages, icon: Mail, color: 'red' },
    { label: 'Bekleyen Teklifler', value: stats.quotes, icon: MessageSquare, color: 'yellow' },
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-600',
    red: 'bg-red-100 text-red-600',
    yellow: 'bg-yellow-100 text-yellow-600',
  };

  return (
    <AdminLayout>
      <div>
        <h1 
          className="text-3xl font-bold text-gray-900 mb-8"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}
          data-testid="dashboard-title"
        >
          Dashboard
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {statCards.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div 
                key={index} 
                className="bg-white rounded-xl p-6 shadow-sm border border-gray-200"
                data-testid={`stat-card-${index}`}
              >
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${colorClasses[stat.color]}`}>
                    <Icon className="w-6 h-6" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  {stat.value}
                </div>
                <div className="text-sm text-gray-600">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;